import { Link } from "react-router-dom";
import { usePortal } from "../../../context/PortalContext";
import { getPlatformUrl } from "../../../utils/portalHost";
import s from "../clinic.module.css";

export default function ClinicNotFound() {
  const { subdomain } = usePortal();

  return (
    <div className={s.bookPage}>
      <div className={s.bookCard} style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: 22, marginBottom: 12 }}>Клуб не найден</h1>
        <p style={{ color: "var(--color-text-muted)", marginBottom: 24 }}>
          Поддомен <strong>{subdomain}</strong> не зарегистрирован в системе.
        </p>
        <a href={getPlatformUrl("/")} className={`${s.btn} ${s.btnPrimary}`}>
          На главную платформы
        </a>
        <p style={{ marginTop: 16, fontSize: 14 }}>
          <a href={getPlatformUrl("/find")}>Найти другую клуб</a>
        </p>
      </div>
    </div>
  );
}
